import { useId } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { fluid } from "../theme/theme";

/**
 * Campo con la etiqueta encima, como en el diseño original de acceso, en
 * lugar de la etiqueta flotante que trae MUI por defecto.
 *
 * La etiqueta se asocia al campo con `htmlFor`, de modo que sigue siendo
 * accesible y pulsable.
 */
export function LabeledField({
  label,
  required = false,
  helperText,
  dense = false,
  slotProps,
  wrapperSx,
  ...fieldProps
}) {
  const id = useId();

  return (
    <Box
      sx={{ mb: dense ? { xs: 1.1, sm: 1.75 } : 2.25, ...wrapperSx }}
    >
      <Typography
        component="label"
        htmlFor={id}
        sx={{
          display: "block",
          mb: dense ? { xs: 0.6, sm: 1 } : 1,
          fontSize: fluid(12.5, 13),
          fontWeight: 600,
          color: "text.primary",
        }}
      >
        {label}
        {required && (
          <Box component="span" sx={{ color: "primary.main", ml: 0.5 }}>
            *
          </Box>
        )}
      </Typography>

      <TextField
        {...fieldProps}
        id={id}
        required={required}
        helperText={helperText}
        slotProps={slotProps}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            minHeight: dense ? { xs: 42, sm: 47 } : 47,
            "& fieldset": { borderColor: "divider" },
            "&:hover fieldset": { borderColor: "text.secondary" },
            "&.Mui-focused fieldset": { borderColor: "primary.main" },
          },
          "& .MuiOutlinedInput-input": {
            paddingBlock: dense ? { xs: "9px", sm: "12px" } : "12px",
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
            fontSize: "0.72rem",
            lineHeight: 1.25,
          },
          ...fieldProps.sx,
        }}
      />
    </Box>
  );
}
